// extracted by mini-css-extract-plugin
module.exports = {"errPage":"FQL_7WL3","link":"__0zzTJkQf"};